<div id="matDialogContent" [class.wba]="detectedPlattform != 'WEB'">
  <form id="passwort-vergessen" [formGroup]="passwort_vergessen"  (ngSubmit)="on_submit(input.value)">
    <div id="matDialogContentData">
    <span id="password_vergessen_span">
      Bitte geben Sie Ihre Kundennummer ein.<br>
      Wir senden Ihnen per E-Mail einen Link zum Zurücksetzen Ihres Passwortes zu.
    </span>
    <input formControlName="kundennummer" placeholder="Kundennummer" type="number" #input>
    </div>
    <div id="matDialogFooter" [class.wba]="detectedPlattform != 'WEB'" *ngIf="detectedPlattform != 'WEB'">
      <button *ngIf="!send" type="submit" [disabled]="!passwort_vergessen.valid">Kundennummer überprüfen</button>
      <button mat-dialog-close *ngIf="send" (click)="navigation_login()">Zurück zum Login</button>
    </div>
  </form>
</div>
